/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationActionBaseRequest {
    getFixupPrototypeFunction() { return ScheduleRecommendationActionBaseRequest.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationActionBaseRequest>): ScheduleRecommendationActionBaseRequest {
        let obj = Object.assign(new ScheduleRecommendationActionBaseRequest(), model);
        ScheduleRecommendationActionBaseRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationActionBaseRequest>): ScheduleRecommendationActionBaseRequest {
        if (!model) return null;
        return ScheduleRecommendationActionBaseRequest.newInstance(<ScheduleRecommendationActionBaseRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationActionBaseRequest) {
        if (!obj) return;

        models.ScheduleRecommendationActionBaseRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationActionBaseRequest): boolean {
        Object.setPrototypeOf(obj, ScheduleRecommendationActionBaseRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenant Id
     */
    tenant_id: string;

    /**
     * Recommendation id
     */
    recommendation_id: string;

    /**
     * Schedule Finding Type
     */
    schedule_finding: models.ScheduleFinding;

    /**
     * List of from_times or days for the recommendation
     */
    schedule_periods: Array<string>;

}
